// const getViewComponent = process.env.NODE_ENV === 'production' ? (path) => (resolve) => require(['@/views' + path + '.vue'], resolve) : (path) => require('@/views' + path + '.vue')

const getViewComponent = (path) => (resolve) => require(['@/views' + path + '.vue'], resolve)

export default [{
        path: '/',
        component: getViewComponent('/common/index'),
        children: [
			// {path:"/",redirect:"/user/userlist"},
			{
				path: '/order/divideSupply',
				component: getViewComponent('/order/divideSupply'),
				meta: {
					title: '人工分账'
				}
			},
			{ path: '/comment/list', component: getViewComponent('/comment/list'), meta: { title: '评论管理' } },
			{ path: '/money/account', component: getViewComponent('/money/account'), meta: { title: '待人工分账' } },
			{ path: '/money/refundRecords', component: getViewComponent('/money/refundRecords'), meta: { title: '退款记录' } },
			{ path: '/money/transferRecords', component: getViewComponent('/money/transferRecords'), meta: { title: '转账记录' } },
			{ path: '/cash', component: getViewComponent('/cash'), meta: { title: '提现管理' } },
			{ path: '/patient/list', component: getViewComponent('/patient/list'), meta: { title: '患者库' } },
			{ path: '/patient/detail', component: getViewComponent('/patient/detail'), meta: { title: '患者信息' } },

			/* 基础设置 */
			{ path: '/web/galleryList', component: getViewComponent('/web/galleryList'), meta: { title: '轮播图列表' } }, //预览轮播图
			/* 注册管理 */
			{ path: '/user/userlist', component: getViewComponent('/user/userlist'), meta: { title: '注册用户' } }, //预览注册用户

			/* 信息统计 */
			{ path: '/order/list', component: getViewComponent('/order/list'), meta: { title: '订单记录' } }, //预览订单记录
			{ path: '/order/income', component: getViewComponent('/order/income'), meta: { title: '订单受益表' } },
			{ path: '/doctor/list', component: getViewComponent('/doctor/list'), meta: { title: '业务员' } },
			{ path: '/doctor/goodsDivide', component: getViewComponent('/doctor/goodsDivide'), meta: { title: '产品分成' } },
			{ path: '/doctor/more', component: getViewComponent('/doctor/more'), meta: { title: '更多信息' } },

          /* 商品*/
          { path: '/content/list', component: getViewComponent('/content/list'), meta: { title: '商品列表' } },
          { path: '/content/add', component: getViewComponent('/content/add'), meta: { title: '商品编辑' } },
          { path: '/content/type', component: getViewComponent('/content/type'), meta: { title: '商品分类管理' } },
          { path: '/content/mtype', component: getViewComponent('/content/mtype'), meta: { title: '商品二级分类' } },
		      { path: '/information/activity', component: getViewComponent('/information/activity'), meta: { title: '促销活动' } },

          /* 在线评估的问题 */
          { path: '/survey/questionList', component: getViewComponent('/survey/questionList'), meta: { title: '在线评估问题集合' } },
          { path: '/survey/addQuestion', component: getViewComponent('/survey/addQuestion'), meta: { title: '在线评估问题设置' } },
          { path: '/survey/resultList', component: getViewComponent('/survey/resultList'), meta: { title: '在线评估得分区间' } },
          { path: '/survey/addResult', component: getViewComponent('/survey/addResult'), meta: { title: '在线评估得分结果设置' } },
          { path: '/survey/replyRecordList', component: getViewComponent('/survey/replyRecordList'), meta: { title: '评估记录' } },
          { path: '/survey/replyDetails', component: getViewComponent('/survey/replyDetails'), meta: { title: '评估详情' } },

          /* 在线评估的问题 */
          { path: '/salesman/list', component: getViewComponent('/salesman/list'), meta: { title: '业务员管理' } },
          { path: '/money/checking', component: getViewComponent('/money/checking'), meta: { title: '财务对账' } },
        ],

        meta: { title: '基因检测' }
    },

    { path: '/login', component: getViewComponent('/common/login'), meta: { title: '登录-基因检测' } }
]



// WEBPACK FOOTER //
// ./src/routes/routes.js